import * as React from 'react';
import { localizedString } from '@locale/index';
import {
  BodyGroup,
  NiCard,
  NiTagsInput,
  RequiredSymbol,
  TextResponse
} from '@component/index';
import {
  isEqual
} from '@lib/index';

import './triggers.less';

interface TriggersProps {
  title?: string;
  wrapType?: 'group' | 'card';
  disabled?: boolean;
  data: string[];
  titleExtra?: React.ReactNode;
  required?: boolean;
  onChange: (next: string[]) => void;
}

interface TriggersState {
  data: string[];
}

export class Triggers extends React.Component<TriggersProps, TriggersState> {

  state = {
    data: []
  };
  componentDidMount() {
    this.onInit();
  }

  componentDidUpdate(prevProps: any) {
    if (!isEqual(prevProps.data, this.props.data)) {
      this.onInit();
    }
  }

  onInit = () => {
    this.setState({ data: this.props.data });
  }

  render() {
    const props = this.props;

    return props.wrapType === 'card'
      ? <NiCard
        titleExtra={props.titleExtra}
        className="trigger-wrap-card"
        title={props.title ?? localizedString('triggers')}
      >
        {this.contentComp()}
      </NiCard>
      : <BodyGroup
        noPadding
        titleExtra={props.titleExtra} title={localizedString('triggers')}
        extra={[]}
      >
        {this.contentComp()}
      </BodyGroup >;
  }

  contentComp = () => {
    const state = this.state;
    const props = this.props;

    return <>
      <TextResponse
        disableReferenceMode
        forList
        disableChange={props.disabled}
        placeholder={localizedString('triggers_placeholder')}
        data={state.data || []}
        update={(next: string[]) => {
          this.handleChange(next);
          setTimeout(this.onBlur, 100);
        }}
        parameterMap={{}}

      />
      {/* <NiTagsInput
        disabled={props.disabled}
        className={props.required ? 'required' : ''}
        value={state.data || []}
        placeholder={getString('triggers_placeholder')}
        onChange={this.handleChange}
        onBlur={this.onBlur}
      /> */}
      {
        props.required &&
        <div style={{ color: 'red' }}>{localizedString('common_content_required')}</div>
      }
    </>;
  }

  handleChange = (next: string[]) => {
    this.setState({
      data: next
    });
  }

  onBlur = () => {
    this.props.onChange(this.state.data);
  }
}
